export default __webpack_public_path__ + "static/media/chatdesk_video_thumbnail.b61b6b9a.png";